module.exports = __webpack_public_path__ + "img/nav-right-expand-search-infiniti.1cd4aa3b.png";